import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Filter.css';

interface SidebarQuickLinksProps {
  /** Called after a link is followed (e.g. to close the mobile drawer). */
  onNavigate?: () => void;
}

export default function SidebarQuickLinks({ onNavigate }: SidebarQuickLinksProps) {
  const { user } = useAuth();

  return (
    <div className={`sb-quick-links${user ? ' sb-quick-links--pair' : ''}`}>
      {user && (
        <Link className="btn btn-soft-primary sb-quick-links__btn" to="/teknik-destek" onClick={onNavigate}>
          <i className="fas fa-headset" aria-hidden="true" />
          Teknik Destek
        </Link>
      )}
      <Link className="btn btn-primary sb-quick-links__btn" to="/gonderiler" onClick={onNavigate}>
        <i className="fas fa-paper-plane" aria-hidden="true" />
        Gönderiler
      </Link>
    </div>
  );
}
